import React from 'react';
import { FieldArray } from 'react-final-form-arrays';
import { Field } from 'react-final-form';
import { FieldSelect } from '../../../components';
import css from './BeneficiaryInfoField.module.css';
import { FormattedMessage, useIntl } from 'react-intl';

const BeneficiaryInfoField = props => {
  const { push, author } = props;
  const intl = useIntl();
  const classes = author?.attributes?.profile?.publicData?.classes || [];

  return (
    <div className={css.wrapper}>
      <div className={css.dynamicFieldsLabel}>
        <p>
          <FormattedMessage id="BeneficiaryInfoField.whoContributeToText" />
        </p>
      </div>

      <div className={css.dynamicFieldsWrapper}>
        <FieldArray name="beneficiaryInfo">
          {({ fields }) =>
            fields.map((name, index) => (
              <div className={css.dynamicFieldWrapper} key={name}>
                {index !== 0 && (
                  <div className={css.closeIconWrapper}>
                    <div onClick={() => fields.remove(index)} style={{ cursor: 'pointer' }}>
                      X
                    </div>
                  </div>
                )}
                <label className={css.dynamicItemLabel}>
                  <FormattedMessage id="BeneficiaryInfoField.beneficiaryLabel" /> {index + 1}
                </label>

                <p className={css.fieldLabel}>Prénom</p>
                <Field
                  name={`${name}.firstName`}
                  className={css.dynamicField}
                  component="input"
                  placeholder={intl.formatMessage({
                    id: 'BeneficiaryInfoField.placeholder',
                  })}
                />
                <p className={css.fieldLabel}>Nom</p>

                <Field
                  name={`${name}.lastName`}
                  className={css.dynamicField}
                  component="input"
                  placeholder={intl.formatMessage({
                    id: 'BeneficiaryInfoField.placeholder',
                  })}
                />
                <p className={css.fieldLabel}>Classe</p>

                {classes.length ? (
                  <FieldSelect
                    id={`${name}.class`}
                    className={css.quantityField}
                    name={`${name}.class`}
                  >
                    <option value="" disabled selected hidden>
                      Choisissez la classe
                    </option>
                    {classes.map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                  </FieldSelect>
                ) : (
                  <Field
                    name={`${name}.class`}
                    className={css.dynamicField}
                    component="input"
                    placeholder={intl.formatMessage({
                      id: 'BeneficiaryInfoField.placeholder',
                    })}
                  />
                )}
              </div>
            ))
          }
        </FieldArray>
      </div>

      <div className={css.addButton} onClick={() => push('beneficiaryInfo', undefined)}>
        {intl.formatMessage({
          id: 'BeneficiaryInfoField.beneficiaryInfoLink',
        })}
      </div>
    </div>
  );
};

export default React.memo(BeneficiaryInfoField);
